import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=d7721038&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7721038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7721038')) {
      api.createRecord('d7721038', component.options)
    } else {
      api.reload('d7721038', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=d7721038&scoped=true&", function () {
      api.rerender('d7721038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/Footer.vue"
export default component.exports